import { createFileRoute, redirect } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'
import { isViewableSuccessor } from '@navigator/entityTypeAccess'
import { SubEntityGridView } from '@navigator/EntityPage/view/SubEntityGridView'
import { EntityTypeQueries } from '@shared/data'
import { useGridViewState } from '@shared/data/GridViewState'

export const Route = createFileRoute('/_auth/entity/$entityId/_breadcrumbs/$subEntityCode')({
  component: RouteComponent,
  params: zodValidator(
    z.object({
      entityId: z.coerce.number(),
      subEntityCode: z.string().min(1).max(3),
    }),
  ),
  validateSearch: z.object({
    utm_source: z.enum(['breadcrumb']).optional(),
    p: z.number().optional(),
  }),
  beforeLoad: async ({
    params: { entityId, subEntityCode },
    context: { queryClient, entityType, scopedEnablements },
  }) => {
    const catalog = await queryClient.ensureQueryData(EntityTypeQueries.userEntityTypes())
    if (!isViewableSuccessor(subEntityCode, entityType.successors, catalog, scopedEnablements)) {
      throw redirect({
        to: '/entity/$entityId',
        params: { entityId },
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  const search = Route.useSearch()
  const { entity } = Route.useRouteContext()
  const { subEntityCode } = Route.useParams()

  useGridViewState()

  return (
    <SubEntityGridView
      parentEntity={entity}
      subEntityCode={subEntityCode}
      perspectiveId={search.p}
    />
  )
}
